module.exports = __webpack_public_path__ + "img/goal-eighteen-en.5edc2f15.png";